// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__HE1So","info":"UpdateTermsInfo_info__3p0PW"};